import Vue from 'vue'
import Router from 'vue-router'


/** For Kneexpert **/
import Index from '@/components/kneexpert/Index'
import SearchDepartmentWiseDoctors from '@/components/kneexpert/SearchDepartmentWiseDoctors'
import SearchHospitalDoctors from '@/components/kneexpert/SearchHospitalDoctors'
import SearchDoctors from '@/components/kneexpert/SearchDoctors'
import DescribeComplain from '@/components/kneexpert/DescribeComplain'
import SearchComplain from '@/components/kneexpert/SearchComplain'
import IpadComplain from '@/components/kneexpert/IpadComplain'
import TabComplain from '@/components/kneexpert/TabComplain'
import Contact_Us from '@/components/kneexpert/Contact_Us'
import HospitalDoctors from '@/components/kneexpert/HospitalDoctors'
// doctor
import Hospitals from '@/components/kneexpert/Hospitals'
import TratementPlan from '@/components/kneexpert/TratementPlan'
import AutomatedPatientEncounter from '@/components/kneexpert/AutomatedPatientEncounter'
import Comprehensive from '@/components/kneexpert/Comprehensive'
import DigitalStroageMadicalRecords from '@/components/kneexpert/DigitalStroageMadicalRecords'
import DetailedComplainetAnalysis from '@/components/kneexpert/DetailedComplainetAnalysis'
import EasyAccessHealthcarePractice from '@/components/kneexpert/EasyAccessHealthcarePractice'
import EncounterDetailed from '@/components/kneexpert/EncounterDetailed'
import FinancialReciept from '@/components/kneexpert/FinancialReciept'
import MultipleHospital from '@/components/kneexpert/MultipleHospital'
import OnlineAppointmentBooking from '@/components/kneexpert/OnlineAppointmentBooking'
import OnlineCollabrations from '@/components/kneexpert/OnlineCollabrations'
import PatientPortal from '@/components/kneexpert/PatientPortal'
import DoctorRegister from '@/components/kneexpert/doctor/Register'
import MyMasters from '@/components/kneexpert/doctor/MyMasters'
import DoctorProfile from '@/components/kneexpert/doctor/Profile'
import Appointments from '@/components/kneexpert/doctor/Appointments'
import DoctorDashboard from '@/components/kneexpert/doctor/Index'
import ProfileSettings from '@/components/kneexpert/doctor/ProfileSettings'
import MyTreatmentPlan from '@/components/kneexpert/doctor/MyTreatmentPlan'
import ExercisePlan from '@/components/kneexpert/doctor/ExercisePlan'
import MyExercisePlan from '@/components/kneexpert/doctor/MyExcersisePlan'
import TreatmentPlan from '@/components/kneexpert/doctor/TreatmentPlan'
import MyPatients from '@/components/kneexpert/doctor/MyPatients'
import SocialMedia from '@/components/kneexpert/doctor/SocialMedia'
import Reviews from '@/components/kneexpert/doctor/Reviews'
import PatientEncounter from '@/components/kneexpert/doctor/PatientEncounter'
import PatientEncounterNew from '@/components/kneexpert/doctor/PatientEncounterNew'
import NewScheduleTimings from '@/components/kneexpert/doctor/NewScheduleTimings'
import NewExercisePlan from  '@/components/kneexpert/doctor/NewExercisePlan'
import Prescription from '@/components/kneexpert/doctor/Prescription'
import Investigation from '@/components/kneexpert/doctor/Investigation'
import Diagnosis from '@/components/kneexpert/doctor/Diagnosis'
import addDiagnosis from '@/components/kneexpert/doctor/addDiagnosis'
import addGeneralAdvice from '@/components/kneexpert/doctor/addGeneralAdvice'
import addInvestigation from '@/components/kneexpert/doctor/addInvestigation'
import addPrescription from '@/components/kneexpert/doctor/addPrescription'
import addSurgery from '@/components/kneexpert/doctor/addSurgery'
import addSymptom from '@/components/kneexpert/doctor/addSymptom'
import Surgery from '@/components/kneexpert/doctor/Surgery'
import Symptoms from '@/components/kneexpert/doctor/Symptoms'
import GeneralAdvice from '@/components/kneexpert/doctor/GeneralAdvice'
import HospitalList from '@/components/kneexpert/doctor/HospitalList'
import ScheduleTimings from '@/components/kneexpert/doctor/ScheduleTimings'
import Reciept from '@/components/kneexpert/doctor/Reciept'
import UpdateTreatmentPlan from '@/components/kneexpert/doctor/UpdateTreatmentPlan'
import ReceiptDetails from '@/components/kneexpert/doctor/ReceiptDetails'
import AddHospital from '@/components/kneexpert/doctor/AddHospital'
import OnBoarding from '@/components/kneexpert/doctor/OnBoarding'
import videolibrary from '@/components/kneexpert/doctor/videolibrary'
import Training from '@/components/kneexpert/doctor/Training.vue'
import MyServices from '../components/kneexpert/doctor/MyServices.vue'
import Referal from '../components/kneexpert/doctor/Referal.vue'
// patient
import Booking from '@/components/kneexpert/patient/Booking'
import PatientRegister from '@/components/kneexpert/patient/Register'
import RegisterBooking from '@/components/kneexpert/patient/Register-Booking'
import Favourites from '@/components/kneexpert/patient/Favourites'
import Dependent from '@/components/kneexpert/patient/Dependent'
import MyEncounter from '@/components/kneexpert/patient/MyEncounter'
import PatientProfileSettings from '@/components/kneexpert/patient/Profile'
import PatientTestimonial from '@/components/kneexpert/patient/PatientTestimonial'
import MedicalRecords from '@/components/kneexpert/patient/MedicalRecords'
import PatientDashboard from '@/components/kneexpert/patient/Index'
import Receipt from '@/components/kneexpert/patient/Receipt'
import ReceiptDetail from '@/components/kneexpert/patient/ReceiptDetail'
import OnBoardings from '@/components/kneexpert/patient/OnBoarding'

//hospital
// import HospitalDashboard from '@/components/kneexpert/hospital/index'
import Appointment from '@/components/kneexpert/hospital/Appointment'
import Doctors from '@/components/kneexpert/hospital/Doctors'
import Encounters from '@/components/kneexpert/hospital/Encounters'
import Patients from '@/components/kneexpert/hospital/Patients'
import SocialMedias from '@/components/kneexpert/hospital/SocialMedia'
import Review from '@/components/kneexpert/hospital/Reviews'
import Receipts from '@/components/kneexpert/hospital/Receipts'
import Profiles from '@/components/kneexpert/hospital/Profile'
import UpdatePatientEncounter from '@/components/kneexpert/hospital/UpdatePatientEncounter'
import Hospitalencounter from '@/components/kneexpert/hospital/Hospitalencounter'
import Onboarding from '@/components/kneexpert/hospital/OnBoarding'
// login
import Login from '@/components/kneexpert/Login'
import LoginWithOTP from '@/components/kneexpert/LoginWithOTP'
import EnterForgotPasswordOTP from '@/components/kneexpert/EnterForgotPasswordOTP'
import EnterOTP from '@/components/kneexpert/EnterOTP'
import EnterRegisterOTP from '@/components/kneexpert/EnterRegisterOTP'

import ForgotPassword from '@/components/kneexpert/ForgotPassword'
import CommonChangePassword from '@/components/kneexpert/CommonChangePassword'


import ChangePassword from '@/components/ChangePassword'
import Error from '@/components/admin/error404.vue'

// import authenticate from "./authenticate";
import { isAuthenticated  } from '../router/authenticate';
import Test from '../components/kneexpert/doctor/Test.vue'
import AccountDetails from '../components/kneexpert/doctor/AccountDetails.vue'
import PhysioDashboard from '../components/kneexpert/doctor/PhysioDashboard.vue'


Vue.use(Router)
const router = new Router({
  mode: 'history',
  base: '/',
  // beforeEnter: authenticate,
  routes: [
    {
      path: '/',
      name: 'index-page',
      component: Index
    },
    // {
    //   path: '/login',
    //   name: 'login',
    //   component: Login
    // },

    {
      path: '/',
      name: 'index',
      component: Index
    },

    {
      path: '/ipad-complain',
      name: 'ipad-complain',
      component: IpadComplain
    },
    {
      path: '/tab-complain',
      name: 'tab-complain',
      component: TabComplain
    },

    {
      path: '/doctor/index',
      name: 'doctor-index',
      component: DoctorDashboard,
      beforeEnter: async (to, from, next) => {
        let auth_result = await isAuthenticated()
        if(auth_result == null){
          next()
        }else{
          next(auth_result)
        }
      },
    },

    // {
    //   path: '/encounterdetailed',
    //   name: 'encounter-detailed',
    //   component: EncounterDetailed
    // },

    
    // {
    //   path: '/doctor/dashboard',
    //   name: 'doctor-dashboard',
    //   component: DoctorDashboard
    // },

    {
      path: '/doctor/appointments',
      name: 'doctor-appointments',
      component: Appointments
    },
    {
      path: '/search',
      name: 'search',
      component: SearchDepartmentWiseDoctors
    },
    {
      path: '/search-doctor',
      name: 'search-doctor',
      component: SearchDoctors
    },

    {
      path: '/search-complain',
      name: 'search-complain',
      component: SearchComplain
    },

    {
      path: '/complain',
      name: 'complain',
      component: DescribeComplain
    },

    {
      path: '/searchhospital/:hospital',
      name: 'searchhospital',
      component: SearchHospitalDoctors,
      props: true
    },

    {
      path: '/automatedpatientencounter',
      name: 'automatedpatientencounter',
      component: AutomatedPatientEncounter
    },
    {
      path: '/comprehensive',
      name: 'comprehensive',
      component: Comprehensive
    },
    {
      path: '/digitalmedicalrecords',
      name: 'digitalmedicalrecords',
      component: DigitalStroageMadicalRecords
    },
    {
      path: '/tratementplan',
      name: 'tratementplan',
      component: TratementPlan
    },
    {
      path: '/detailedcomplainet',
      name: 'detailedcomplainet',
      component: DetailedComplainetAnalysis
    },
    {
      path: '/hospitals',
      name: 'hospitals',
      component: Hospitals
    },

    {
      path: '/hospital-doctor/:name',
      name: 'hospital-doctor',
      component: HospitalDoctors
    },
    {
      path: '/contact-us',
      name: 'contact_us',
      component: Contact_Us
    },

    {
      path: '/easyaccesshealthcare',
      name: 'easyaccesshealthcare',
      component: EasyAccessHealthcarePractice
    },
    {
      path: '/encounterdetailed',
      name: 'encounterdetailed',
      component: EncounterDetailed
    },
    {
      path: '/financialreciept',
      name: 'financialreciept',
      component: FinancialReciept
    },
    {
      path: '/multiplehospital',
      name: 'multiplehospital',
      component: MultipleHospital
    },
    {
      path: '/onlineappointment',
      name: 'onlineappointment',
      component: OnlineAppointmentBooking
    },
    {
      path: '/onlinecollabrations',
      name: 'onlinecollabrations',
      component: OnlineCollabrations
    },
    {
      path: '/patientportal',
      name: 'patientportal',
      component: PatientPortal
    },
    {
      path: '/doctor/patients',
      name: 'my-patients',
      component: MyPatients
    },
    {
      path: '/doctor/new-schedule-timings',
      name: 'new-schedule-timings',
      component: NewScheduleTimings
    },
    {
      path: '/doctor/edit-schedule-timings/:id',
      name: 'edit-schedule-timings',
      component: NewScheduleTimings
    },


    {
      path: '/doctor/video-library',
      name: 'video-library',
      component: videolibrary
    },

    {
      path: '/doctor/training',
      name: 'training',
      component: Training
    },

    {
      path: '/doctor/my-services',
      name: 'my-services',
      component: MyServices
    },
    
    {
      path: '/doctor/referal',
      name: 'referal',
      component: Referal
    },

    {
      path: '/doctor/account-details',
      name: 'account-details',
      component: AccountDetails
    },
    {
      path: '/doctor/edit-exercise-plan/',
      name: 'edit-exercise-plan',
      component: NewExercisePlan
    },
    {
      path: '/doctor/prescription',
      name: 'prescription',
      component: Prescription
    },
    {
      path: '/doctor/investigation',
      name: 'investigation',
      component: Investigation
    },

    {
      path: '/doctor/diagnosis',
      name: 'diagnosis',
      component: Diagnosis
    },

    {
      path: '/doctor/add-diagnosis',
      name: 'add-diagnosis',
      component: addDiagnosis
    },
    {
      path: '/doctor/add-general-advice',
      name: 'add-general-advice',
      component: addGeneralAdvice
    },
    {
      path: '/doctor/add-investigation',
      name: 'add-investigation',
      component: addInvestigation
    },
    {
      path: '/doctor/add-prescription',
      name: 'add-prescription',
      component: addPrescription
    },
    {
      path: '/doctor/add-surgery',
      name: 'add-surgery',
      component: addSurgery
    },

    {
      path: '/doctor/add-symptom',
      name: 'add-symptom',
      component: addSymptom
    },

    {
      path: '/doctor/schedule-timings',
      name: 'schedule-timings',
      component: ScheduleTimings
    },
    {
      path: '/doctor/reviews',
      name: 'doctor-reviews',
      component: Reviews
    },

    {
      path: '/doctor/physio-dashboard',
      name: 'physio-dashboard',
      component: PhysioDashboard
    },

    {
      path: '/doctor/reciept',
      name: 'reciept',
      component: Reciept
    },
    {
      path: '/doctor/new-patient-encounter/:patient_id?/:appointment_id?',
      name: 'new-patient-encounter',
      component: PatientEncounterNew
    },
    {
      path: '/doctor/receipt-details/:receiptId?',
      name: 'receipt-details',
      component: ReceiptDetails
    },
    {
      path: '/doctor/update-patient-encounter/:patient_id?/:appointment_id?/:encounter_id?',
      name: 'update-patient-encounter-update',
      component: Test
    },
    {
      path: '/doctor/patient-encounter',
      name: 'patient-encounter',
      component: PatientEncounter
    },

    {
      path: '/doctor/profile-settings',
      name: 'profile-settings',
      component: ProfileSettings
    },
    {
      path: '/doctor/add-hospital',
      name: 'add-hospital',
      component: AddHospital
    },
    {
      path: '/doctor/my-treatment-plan',
      name: 'my-treatment-plan',
      component: MyTreatmentPlan
    },
    {
      path: '/doctor/update-treatment-plan/:userId?',
      name: 'update-treatment-plan',
      component: UpdateTreatmentPlan
    },
    {
      path: '/doctor/my-exercise-plan',
      name: 'my-exercise-plan',
      component: MyExercisePlan
    },
    {
      path: '/doctor/treatment-plan',
      name: 'treatment-plan',
      component: TreatmentPlan
    },
    {
      path: '/doctor/exercise-plan',
      name: 'exercise-plan',
      component: ExercisePlan
    },
    {
      path: '/doctor/surgery',
      name: 'surgery',
      component: Surgery
    },
    {
      path: '/doctor/symptoms',
      name: 'symptoms',
      component: Symptoms
    },
    {
      path: '/doctor/general-advice',
      name: 'general-advice',
      component: GeneralAdvice
    },
    {
      path: '/doctor/hospital',
      name: 'hospital',
      component: HospitalList
    },
    {
      path: '/doctor/social-media',
      name: 'social-media',
      component: SocialMedia
    },
    {
      path: '/doctor/change-password',
      name: 'change-password',
      component: ChangePassword
    },
    {
      path: '/doctor/register',
      name: 'doctor-register',
      component: DoctorRegister
    }
    ,
    {
      path: '/doctor/MyMasters',
      name: 'MyMasters',
      component: MyMasters
    },
    {
      path: '/doctor/profile/:name?',
      name: 'doctor-profile',
      component: DoctorProfile,
      beforeEnter: async (to, from, next) => {
        if(to.params.name == undefined) {
          next('/index');
        } else {
          next()
        }
      }
    },
    {
      path: '/patient/index',
      name: 'patient-dashboard',
      component: PatientDashboard,
      beforeEnter: async (to, from, next) => {
        let auth_result = await isAuthenticated()
        if(auth_result == null){
          next()
        }else{
          next(auth_result)
        }
      },
    },
    {
      path: '/patient/booking/:name?',
      name: 'booking',
      component: Booking,
      beforeEnter: async (to, from, next) => {
        if(to.params.name == undefined) {
          next('/index');
        } else {
          next()
        }
      }
    },
    // {
    //   path: '/patient/dashboard',
    //   name: 'patient-dashboard',
    //   component: PatientDashboard
    // },
    {
      path: '/patient/favourites',
      name: 'favourites',
      component: Favourites
    },
    {
      path: '/patient/testimonial',
      name: 'patient-testimonial',
      component: PatientTestimonial
    },
    
    {
      path: '/patient/profile',
      name: 'patient-profile-settings',
      component: PatientProfileSettings
    },
    {
      path: '/patient/change-password',
      name: 'patient-change-password',
      component: ChangePassword
    },
    {
      path: '/patient/dependent',
      name: 'dependent',
      component: Dependent
    },
    {
      path: '/patient/receipt',
      name: 'receipt',
      component: Receipt
    },
    {
      path: '/patient/receipt-detail/:receiptId?',
      name: 'receipt-detail',
      component: ReceiptDetail
    },
    {
      path: '/patient/my-encounter',
      name: 'my-encounter',
      component: MyEncounter
    },
    {
      path: '/login-with-username',
      name: 'logins',
      component: Login,
      beforeEnter: async (to, from, next) => {
        let auth_result = localStorage.getItem("userInfo");
        if(auth_result !== null){
          next('/doctor/index');
        }
        else{
          next();
        }
      },
    },
    {
      path: '/patient/register',
      name: 'patient-register',
      component: PatientRegister
    },
    {
      path: '/patient/medical-records',
      name: 'medical-records',
      component: MedicalRecords
    },


    //Hospital routes
    {
      path: '/hospital/appointment',
      name: 'hospital-appointment',
      component: Appointment,
      beforeEnter: async (to, from, next) => {
        let auth_result = await isAuthenticated()
        if(auth_result == null){
          next()
        }else{
          next(auth_result)
        }
      },
    },

    {
      path: '/hospital/on-boarding',
      name: 'on-boarding',
      component: Onboarding
    },

    {
      path: '/hospital/appointment',
      name: 'hospital-appointment',
      component: Appointment
    },
    {
      path: '/hospital/doctor',
      name: 'doctor',
      component: Doctors
    },
    {
      path: '/hospital/hospital-encounter',
      name: 'hospital-encounter',
      component: Hospitalencounter
    },
    {
      path: '/hospital/patient',
      name: 'patient',
      component: Patients
    },
    {
      path: '/hospital/patient',
      name: 'patient',
      component: Patients
    },
    {
      path: '/hospital/social-media',
      name: 'social-media',
      component: SocialMedias
    },
    {
      path: '/hospital/hospital-reviews',
      name: 'hospital-reviews',
      component: Review
    },
    {
      path: '/hospital/hospital-reciept',
      name: 'hospital-reciept',
      component: Receipts
    },
    {
      path: '/hospital/hospital-settings',
      name: 'hospital-settings',
      component: Profiles
    },


    {
      path: '/hospital/update-patient-encounter/:patient_id?/:appointment_id?',
      name: 'update-patient-encounter',
      component: UpdatePatientEncounter
    },

    {
    path: '/hospital/hospital-update-patient-encounter/:patient_id?/:appointment_id?/:encounter_id?',
    name: 'hospital-update-patient-encounter',
    component: UpdatePatientEncounter
  },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: ForgotPassword,
      beforeEnter: async (to, from, next) => {
        let auth_result = localStorage.getItem("userInfo");
        if(auth_result !== null){
          next('/doctor/index');
        }
        else{
          next();
        }
      },
    },
    {
      path: '/change-password',
      name: 'common-change-password',
      component: CommonChangePassword,
      props: true,
      beforeEnter: async (to, from, next) => {
        if(from && from.name == 'forgot-password-enter-OTP'){
          next()
        }else{
          next('/forgot-password');
        }
      },
    },
    {
      path: '/forgot-password/enter-OTP',
      name: 'forgot-password-enter-OTP',
      component: EnterForgotPasswordOTP,
      props: true,
      beforeEnter: async (to, from, next) => {
        if(from && from.name == 'forgot-password'){
          next()
        }else{
          next('/forgot-password');
        }

      },
    },
    {
      path: '/login',
      name: 'login',
      component: LoginWithOTP,
      beforeEnter: async (to, from, next) => {
        let auth_result = localStorage.getItem("userInfo");
        if(auth_result !== null){
          next('/doctor/index');
        }
        else{
          next();
        }
      },
    },
    {
      path: '/enter-OTP',
      name: 'enter-OTP',
      component: EnterOTP,
      props: true,
      beforeEnter: async (to, from, next) => {
        if(from && from.name == 'login'){
          next()
        }else{
          next('/login');
        }

      },
    },
    {
      path: '/enter-register-OTP',
      name: 'enter-register-OTP',
      component: EnterRegisterOTP,
      props: true,
      beforeEnter: async (to, from, next) => {
        if(from && from.name == 'patient-register' || from.name == 'doctor-register' || from.name == 'register-booking'){
          next()
        }else{
          next('/login');
        }

      },
    },
    {
      path: '/register-booking',
      name: 'register-booking',
      component: RegisterBooking,
      props: true,
    },

    { path: "*", 
      component: Error 
    }
  ],
  linkActiveClass: "active",
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js